import Icon from 'veui/components/Icon'
import { IconUserTieba } from 'dls-icons-vue'

Icon.register('user-tieba', IconUserTieba)
